import { Input } from '@yes.technology/react-toolkit'
import { ActivityValue, StatusClass } from 'types/shared'

type ActivityInputAreaProps = {
  id: string
  statusClass: StatusClass
  informational?: boolean
  required?: boolean
  value: string
  onChange: (value: ActivityValue) => void
  label: string
  helpText?: string
  explanationText?: string
  disabled?: boolean
}

function ActivityInputArea({
  id,
  statusClass,
  informational,
  required,
  value,
  onChange,
  label,
  helpText,
  explanationText,
  disabled
}: ActivityInputAreaProps) {
  return (
    <Input
      component='textarea'
      id={id}
      label={label}
      placeholder={helpText || explanationText}
      value={value}
      onChange={onChange}
      required={required}
      informational={informational}
      statusClass={statusClass}
      heightClass='regular'
      disabled={disabled}
    />
  )
}

export default ActivityInputArea
